import dayjs from 'dayjs';
import { AxiosResponse } from 'axios';
import {
  REPORT_01,
  REPORT_02,
  REPORT_03,
  REPORT_04,
  REPORT_05,
  REPORT_06,
  REPORT_07,
  REPORT_08,
  REPORT_09,
  REPORT_ST01,
  REPORT_ST02,
  REPORT_ST03,
  REPORT_ST04,
  REPORT_Z01,
} from './constants';
import ApiService from '../../Services/ApiService';
import LoaderService from '../../Services/LoaderService';
import { IValidationRule } from '../../Services/FormikValidatorService';
import { getRequest } from '../../Services/HttpService';

export const handleDownloadRequest = async (url: string, values: any) => {
  const res = await ApiService.post(url.replace('/api', ''), values);
  return res;
};

export const getDownloads = async () => {
  const response = await ApiService.get(`/v2/report/available`);
  if (response && response.data && response.data.data && response.data.data.available === true) {
    return true;
  }
  return false;
};

export const getReports = async () => {
  LoaderService.showLoader();
  const response = await ApiService.get(`/v2/report/list`);
  LoaderService.showLoader(false);
  if (response.data && response.data.reports && response.status === 200) {
    const options = response.data.reports.map((i: any) => {
      return {
        item: `${i.code} - ${i.name}`,
        value: String(i.id),
        tooltip: i.description,
        actionUrl: i.actionUrl,
      };
    });
    return options;
  }
  return false;
};

export const getVehicles = async (reportId: string) => {
  LoaderService.showLoader();
  const response = await ApiService.get(`/v2/report/form/vehicleIds`, {
    reportId,
  });
  LoaderService.showLoader(false);
  if (response.data && response.status === 200) {
    const vehicles = [...response.data];
    vehicles.map((item) => {
      item.value = String(item.value);
      return item;
    });
    return vehicles;
  }
  return false;
};

export const handleReportSettings = (
  userSettingsFromResponse: any,
  reportSettingsOptions: string[],
  reportId?: string
) => {
  let userSettings = null;
  if (userSettingsFromResponse && Object.keys(userSettingsFromResponse).length > 0) {
    userSettings = userSettingsFromResponse;
  }
  if (userSettings) {
    const reportSettings: string[] = [];
    Object.keys(userSettings).forEach((key: string) => {
      if (userSettings && userSettings[key] === true && reportSettingsOptions.includes(key)) {
        reportSettings.push(key);
      }
    });
    return reportSettings;
  }
  return reportId === REPORT_05 ? [] : reportSettingsOptions;
};

export const handleAllowedRange = (dateValidation: IValidationRule[]) => {
  if (dateValidation) {
    const minDate = dateValidation.find((i) => i.param === 'minDate');
    const maxDate = dateValidation.find((i) => i.param === 'maxDate');
    if (minDate && maxDate) {
      return [minDate.value, maxDate.value];
    }
    return undefined;
  }
  return undefined;
};

export const getDrivers = async (reportId: string) => {
  LoaderService.showLoader();
  const response = await ApiService.get(`/v2/report/form/driverId`, {
    reportId,
  });
  LoaderService.showLoader(false);
  if (response.data && response.status === 200) {
    const drivers = [...response.data];
    drivers.map((item) => {
      item.value = String(item.value);
      return item;
    });
    return drivers;
  }
  return false;
};

export const getCustomers = async (reportId: string) => {
  LoaderService.showLoader();
  const response = await ApiService.get(`/v2/report/form/customerIds`, {
    reportId,
  });
  LoaderService.showLoader(false);
  if (response.data && response.status === 200) {
    const customers = [...response.data];
    customers.map((item) => {
      item.value = String(item.value);
      return item;
    });
    return customers;
  }
  return false;
};
export const getBluecoins = async (reportId: string) => {
  LoaderService.showLoader();
  const response: AxiosResponse | false = await getRequest(
    `/v2/report/form/bluecoinIds?reportId=${reportId}`,
    {
      returnAxiosResponse: true,
    }
  );
  LoaderService.showLoader(false);
  if ((response as AxiosResponse).data && (response as AxiosResponse).status === 200) {
    const bluecoins = [...(response as AxiosResponse).data];
    bluecoins.map((item) => {
      item.value = String(item.value);
      return item;
    });
    return bluecoins;
  }
  return false;
};

export const getValidation = async (reportId: string) => {
  LoaderService.showLoader();
  const response = await ApiService.get(`${`/v2/report/validation`}${`?reportId=${reportId}`}`);
  LoaderService.showLoader(false);
  if (
    response.data &&
    response.data.report &&
    response.data.report.form &&
    response.status === 200
  ) {
    return response.data.report;
  }
  return false;
};

export const getValidationWithEntity = async (reportId: string, entity: string) => {
  LoaderService.showLoader();
  const response = await ApiService.get(
    `${`/v2/report/validation`}${`?reportId=${reportId}&entity=${entity}`}`
  );
  LoaderService.showLoader(false);
  if (
    response.data &&
    response.data.report &&
    response.data.report.form &&
    response.status === 200
  ) {
    return response.data.report;
  }
  return false;
};

export const getDatepickerMessage = (range: string) => {
  let message = '';
  switch (range) {
    case 'month':
      message = 'errors.reports.cannotSelectDateLongerThanMonth';
      break;
    case '3months':
      message = 'errors.reports.cannotSelectDateLongerThan3Month';
      break;
    case 'year':
      message = 'errors.reports.cannotSelectDateLongerThanYear';
      break;
    default:
  }
  return message;
};

export const getReportRefDate = (reportId: string, date: Date, range: string, mergeBy?: string) => {
  if (reportId === REPORT_07 && (mergeBy === 'year' || mergeBy === 'month')) {
    range = 'year';
  } else if (reportId === REPORT_Z01) {
    range = 'month';
  }
  let refDate = new Date();
  const newDate = dayjs(new Date(date))
    .set('second', 0)
    .set('millisecond', 0)
    .set('minute', 0)
    .set('hour', 24)
    .toDate();
  switch (range) {
    case 'month':
      refDate = new Date(newDate.setMonth(newDate.getMonth() - 1));
      break;
    case '3months':
      refDate = new Date(newDate.setMonth(newDate.getMonth() - 3));
      break;
    case 'year':
      refDate = new Date(newDate.setFullYear(newDate.getFullYear() - 1));
      break;
    default:
  }
  return refDate;
};

export const getRangeValidity = (
  reportId: string,
  fromDate: Date,
  toDate: Date,
  range: string,
  mergeBy?: string
) => {
  if (getReportRefDate(reportId, toDate, range, mergeBy).getTime() > new Date(fromDate).getTime()) {
    return false;
  }
  return true;
};

export const handleDatepickerValidation = (dates: Date[], reportId: string, range: string) => {
  if (dates && dates.length === 2) {
    const dateFrom = dates[0];
    const dateTo = dates[1];
    if (!getRangeValidity(reportId, dateFrom, dateTo, range)) {
      return getDatepickerMessage(range);
    }
    return '';
  }
  return '';
};

export const getMinDatepickerValue = () => {
  const date = new Date(new Date().setHours(0, 0, 0, 0));
  date.setMonth(date.getMonth() - 24);
  return date;
};

export const getManualReportSettingsKey = (reportId: string): string | null => {
  const keys: { [reportId: string]: string } = {
    [REPORT_01]: 'report_config_r01',
    [REPORT_02]: 'report_config_r02',
    [REPORT_03]: 'report_config_r03',
    [REPORT_04]: 'report_config_r04',
    [REPORT_05]: 'report_config_r05',
    [REPORT_06]: 'report_config_r06',
    [REPORT_07]: 'report_config_r07',
    [REPORT_08]: 'report_config_r08',
    [REPORT_09]: 'report_config_r09',
    [REPORT_Z01]: 'report_config_z01',
    [REPORT_ST01]: 'report_config_st01',
    [REPORT_ST02]: 'report_config_st02',
    [REPORT_ST03]: 'report_config_st03',
    [REPORT_ST04]: 'report_config_st04',
  };
  return keys[reportId] || null;
};
